export { getRelayDataId } from './data-id';
